import React from 'react';

function ContactEditor({ pageContent, setPageContent, uploading, uploadingField, handleImageUpload, deleteImageFromFirebase }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📞 Contact Page Editor</h3>
        <p className="editor-description">Edit contact information and WhatsApp number for enquiries.</p>

        <div className="form-group">
          <label>Page Title</label>
          <input 
            value={pageContent.title || 'Contact Us'} 
            onChange={(e) => setPageContent({...pageContent, title: e.target.value})} 
            className="form-input" 
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>School Name</label>
            <input 
              value={pageContent.schoolName || ''} 
              onChange={(e) => setPageContent({...pageContent, schoolName: e.target.value})} 
              className="form-input" 
            />
          </div>
          <div className="form-group">
            <label>Principal Name</label>
            <input 
              value={pageContent.principalName || ''} 
              onChange={(e) => setPageContent({...pageContent, principalName: e.target.value})} 
              className="form-input" 
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Principal Email</label>
            <input 
              type="email" 
              value={pageContent.principalEmail || ''} 
              onChange={(e) => setPageContent({...pageContent, principalEmail: e.target.value})} 
              className="form-input" 
            />
          </div>
          <div className="form-group">
            <label>School Email</label>
            <input 
              type="email" 
              value={pageContent.email || ''} 
              onChange={(e) => setPageContent({...pageContent, email: e.target.value})} 
              className="form-input" 
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Alternate Email</label>
            <input 
              type="email" 
              value={pageContent.alternateEmail || ''} 
              onChange={(e) => setPageContent({...pageContent, alternateEmail: e.target.value})} 
              className="form-input" 
            />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input 
              type="tel" 
              value={pageContent.phone || ''} 
              onChange={(e) => setPageContent({...pageContent, phone: e.target.value})} 
              className="form-input" 
              placeholder="e.g., +91 1234567890"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Alternate Phone</label>
            <input 
              type="tel" 
              value={pageContent.alternatePhone || ''} 
              onChange={(e) => setPageContent({...pageContent, alternatePhone: e.target.value})} 
              className="form-input" 
            />
          </div>
          <div className="form-group">
            <label>WhatsApp Number</label>
            <input 
              type="tel" 
              value={pageContent.whatsappNumber || ''} 
              onChange={(e) => setPageContent({...pageContent, whatsappNumber: e.target.value})} 
              className="form-input" 
              placeholder="e.g., +91 1234567890"
            />
            <small style={{display: 'block', marginTop: 5, color: '#64748b'}}>
              This number will receive WhatsApp messages from the contact form
            </small>
          </div>
        </div>

        <div className="form-group">
          <label>Address</label>
          <textarea 
            value={pageContent.address || ''} 
            onChange={(e) => setPageContent({...pageContent, address: e.target.value})} 
            rows="3" 
            className="form-input" 
          />
        </div>

        <div className="form-group">
          <label>Office Hours</label>
          <textarea 
            value={pageContent.officeHours || 'Monday to Friday: 8:00 AM - 3:00 PM\nSaturday: 8:00 AM - 12:00 PM\nSunday: Closed'} 
            onChange={(e) => setPageContent({...pageContent, officeHours: e.target.value})} 
            rows="4" 
            className="form-input" 
            placeholder="Enter office hours (one per line)"
          />
        </div>

        <div className="form-group">
          <label>Google Maps Embed Code</label>
          <textarea 
            value={pageContent.googleMapEmbedUrl || ''} 
            onChange={(e) => setPageContent({...pageContent, googleMapEmbedUrl: e.target.value})} 
            rows="5" 
            className="form-input" 
            placeholder='Paste Google Maps iframe embed code here...'
          />
          <small style={{display: 'block', marginTop: 5, color: '#64748b'}}>
            Get embed code from Google Maps → Share → Embed a map
          </small>
        </div>

        <div className="info-box">
          <div className="info-icon">💡</div>
          <div className="info-content">
            <strong>How WhatsApp Integration Works:</strong>
            <ul>
              <li>Visitors fill the contact form with their name, email, subject, and message</li>
              <li>When they click "Send via WhatsApp", a WhatsApp chat opens with pre-filled message</li>
              <li>The message includes all form data and is sent to the configured WhatsApp number</li>
              <li>Make sure the WhatsApp number includes country code (e.g., +91 for India)</li>
              <li>If WhatsApp number is not set, the phone number will be used as fallback</li>
            </ul>
          </div>
        </div>

        <div className="form-group">
          <label>Preview</label>
          <div style={{background: '#f8fafc', padding: 16, borderRadius: 8, fontSize: 14}}>
            <p><strong>🏫 School Name:</strong> {pageContent.schoolName || 'Not set'}</p>
            <p><strong>📞 Phone:</strong> {pageContent.phone || 'Not set'}</p>
            <p><strong>💬 WhatsApp:</strong> {pageContent.whatsappNumber || 'Not set'}</p>
            <p><strong>✉️ Email:</strong> {pageContent.email || 'Not set'}</p>
            <p><strong>📍 Address:</strong> {pageContent.address ? 'Configured ✓' : 'Not set'}</p>
          </div>
        </div>
      </div>

      <style>{`
        .editor-description {
          color: #64748b;
          margin-bottom: 20px;
          font-size: 14px;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 15px;
        }

        .info-box {
          background: #eff6ff;
          border-left: 4px solid #3b82f6;
          padding: 16px;
          border-radius: 12px;
          margin: 20px 0;
          display: flex;
          gap: 12px;
        }

        .info-icon {
          font-size: 20px;
        }

        .info-content {
          flex: 1;
        }

        .info-content strong {
          color: #1e3a8a;
        }

        .info-content ul {
          margin: 8px 0 0 20px;
          color: #64748b;
          font-size: 13px;
        }

        @media (max-width: 768px) {
          .form-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default ContactEditor;